<template>
    <div class="wrapper col">
        <div class="profile">
            <div class="section">
                <UploadImage text="Profile Image" :style="editStyle" :storageRef="storageRef" :img="thisUser.img" @updateImg="updateImg" />
            </div>
            <div class="section">
                <span>Email</span>
                <h2>{{ $store.state.user.data.email }}</h2>
            </div>
            <div class="section">
                <span>First Name</span>
                <input
                    class="text-input"
                    placeholder="First Name"
                    v-if="editEnabled"
                    v-model="thisUser.first"
                    v-on:keyup.enter="submit"
                >
                <h2 v-else>{{ thisUser.first }}</h2>
                <span>Last Name</span>
                <input
                    class="text-input"
                    placeholder="Last Name"
                    v-if="editEnabled"
                    v-model="thisUser.last"
                    v-on:keyup.enter="submit"
                >
                <h2 v-else>{{ thisUser.last }}</h2>
            </div>
            <div class="section">
                <span>Organization</span>
                <input
                    class="text-input"
                    placeholder="What group are you with?"
                    v-model="thisUser.org"
                    v-on:keyup.enter="submit"
                >
                <span>Title</span>
                <input
                    class="text-input"
                    placeholder="What do you do?"
                    v-model="thisUser.title"
                    v-on:keyup.enter="submit"
                >
            </div>
            <div class="section">
                <span>LinkedIn Profile Link</span>
                <input
                    class="text-input"
                    placeholder="LinkedIn Profile URL"
                    v-model="thisUser.profiles.linkedin"
                    v-on:keyup.enter="submit"
                >
                <span>Twitter Profile Link</span>
                <input
                    class="text-input"
                    placeholder="Twitter Profile URL"
                    v-model="thisUser.profiles.twitter"
                    v-on:keyup.enter="submit"
                >
            </div>
        </div>
        <SubmitButton
            @click="submit"
            :isLoading="loading"
            text="Submit"
        />
        <SubmitButton
            @click="$router.push('/logout')"
            text="Log Out"
        />
    </div>
</template>

<script>
import UploadImage from './tools/UploadImage'

import { auth, rtdb, storage } from '../db'

const users = rtdb.ref('users')

export default {
    name: 'Profile',
    components: {
        UploadImage
    },
    data() {
        return {
            userData: {},
            thisUser: {
                profiles: {}
            },
            loading: false,
        }
    },
    methods: {
        submit() {
            if (!this.name) {
                this.error('Don\'t forget to fill in all the fields!')
                return
            }
            this.loading = true
            this.updateUserInfo()
                .then(() => {
                    this.notif('User info updated')
                }).catch( () => {
                    this.error('Error updating user info!')
                }).finally(() => {
                    this.loading = false
                })
        },
        async updateUserInfo() {
            auth.currentUser.updateProfile({
                displayName: this.name
            })
            users.child(auth.currentUser.uid).set(this.thisUser)
                .catch(e => console.log(e.message))
        },
        updateImg(newImg) {
            users.child(auth.currentUser.uid).update(newImg)
        }
    },
    computed: {
        name() {
            if (this.thisUser.first && this.thisUser.last)
                return this.thisUser.first + ' ' + this.thisUser.last
            else
                return ''
        },
        storageRef() {
            return storage.ref().child(`users/${auth.currentUser.uid}`)
        },
        editEnabled() {
            return !auth.currentUser.uid.includes('linkedin')
        },
        editStyle() {
            if (this.editEnabled) {
                return {}
            } else {
                return {
                    pointerEvents: 'none'
                }
            }
        }
    },
    watch: {
        userData: {
            handler(userData) {
                var usr = userData[auth.currentUser.uid]
                if (!usr.profiles) {
                    usr.profiles = {}
                }
                this.thisUser = usr
            }
        }
    },
    created() {
        this.$rtdbBind('userData', users.orderByChild('email').equalTo(auth.currentUser.email))
    }
}
</script>

<style lang="scss" scoped>
@import '../interface.scss';

.profile {
    text-align: left;
    .text-input {
        margin-left: 0;
    }
}
</style>